import { Link } from 'react-router-dom';
import logo1 from '../../assets/logo1.png';

/**
 * Footer component for the landing page
 * @param {Object} props - Component props
 * @param {Function} props.onContactClick - Callback when contact button is clicked
 */
function Footer({ onContactClick }) {
  return (
    <footer className="border-t-2 border-slate-200 bg-gradient-to-br from-slate-50 to-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        {/* Logo and navigation */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src={logo1} alt="Wurlo logo" className="h-10 w-auto" loading="lazy" decoding="async" />
            <div>
              <div className="text-lg font-bold text-slate-900">Wurlo</div>
              <p className="text-sm text-slate-600 mt-0.5">Empowering tutors to teach smarter.</p>
            </div>
          </div>

          {/* Footer navigation */}
          <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-8 gap-y-3">
            <Link to="/terms" className="text-base font-medium text-slate-700 hover:text-indigo-600 focus-ring transition-colors">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy" className="text-base font-medium text-slate-700 hover:text-indigo-600 focus-ring transition-colors">
              Privacy Policy
            </Link>
            <button onClick={onContactClick} className="text-base font-medium text-slate-700 hover:text-indigo-600 focus-ring transition-colors">
              Contact
            </button>
          </nav>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-slate-200 text-sm text-slate-500">
          © <span id="year"></span> Wurlo. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
